import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoDecimalPipe } from './pipe/no-decimal.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecieptComponent } from './Component/reciept/reciept.component';
import { SafePipe } from './pipe/safe.pipe';


const SharedPipes = [
  NoDecimalPipe,
  SafePipe
];

const SharedComponents = [
  RecieptComponent
];

const SharedModules = [
  FormsModule, ReactiveFormsModule
];

@NgModule({
  declarations: [
    ...SharedPipes,
    ...SharedComponents
  ],
  imports: [
    CommonModule, ...SharedModules
  ],
  exports: [
    ...SharedPipes,
    ...SharedComponents,
    ...SharedModules
  ]
})
export class SharedModule { }
